/**
 * Base classes for the component.
 */
export const BASE_CLASS = 'orca-status-toast';

/**
 * Supported themes.
 */
export const THEMES = {
    SUCCESS: 'success',
    ERROR: 'error'
} as const;
